module.exports = __webpack_public_path__ + "img/Indonesian.d339d80e.svg";